import React from 'react';
import { SafeAreaView, StatusBar, useColorScheme } from 'react-native';

import BottomNavigation from './navigation/BottomNavigation';

// import { Colors } from 'react-native/Libraries/NewAppScreen'; //TODO:EXPO
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import FullScreenNavigationGroups from './navigation/FullScreenNavigationGroups';
import { useTheme } from '@react-navigation/native';

const Stack = createNativeStackNavigator();


function Main() {

  const theme = useTheme()
  const isDarkMode = useColorScheme() === 'dark';

  const backgroundStyle = {
    // backgroundColor: isDarkMode ? Colors.darker : Colors.lighter, //TODO:EXPO
    flex: 1
  };

  return (
    <SafeAreaView style={backgroundStyle}>
      <StatusBar barStyle={isDarkMode ? 'light-content' : 'dark-content'} />

      <Stack.Navigator
        screenOptions={{
          headerStyle: { backgroundColor: theme.colors.primary },
          headerTintColor: "#fff",
        }}
      >
        {/* TabBar and its nested screens */}
        <Stack.Screen name="BottomNavigation" component={BottomNavigation} options={{ headerShown: false }} />

        {/* Screens without tabBar displayed (fullscreen) */}
        {FullScreenNavigationGroups(Stack)}
      </Stack.Navigator>
      
    </SafeAreaView >
  );
}

export default Main;
